import homeVideo from "fragments/homeVideos/homeVideo"
import gql from "graphql-tag"

const GET_HOME_VIDEO_BY_ID = gql`
  ${homeVideo}

  query getHomeVideoById($id: ID!) {
    getHomeVideoById(id: $id) {
      ...HomeVideo
    }
  }
`

export default GET_HOME_VIDEO_BY_ID
